import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AuthService } from '../_services/auth.service';
import { UnivPrefsService } from '../_services/univ-prefs.service';
import { School, SchoolsService } from '../_services/schools.service';
import { Router, RouterLink } from '@angular/router';
import { map, startWith } from 'rxjs/operators';
import { combineLatest, Observable } from 'rxjs';
import { EplService } from '_services/epl.service';
import { AsyncPipe } from '@angular/common';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatButton } from '@angular/material/button';
import { DateAgoPipe } from '../_pipes/date-ago.pipe';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatOption } from '@angular/material/core';
import { User } from '../_models/user';



@Component({
  selector: 'app-schools',
  templateUrl: './schools.component.html',
  styleUrls: ['./schools.component.css'],
  imports: [
    RouterLink,
    MatTabGroup,
    MatTab,
    MatSort,
    MatSortHeader,
    MatButton,
    AsyncPipe,
    DateAgoPipe,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatAutocompleteTrigger,
    MatAutocomplete,
    MatOption,
  ]
})
export class SchoolsComponent {

  userSchools: Observable<string[]>;
  schoolSearchControl = new FormControl('');
  filteredSchools: Observable<School[]>;

  constructor(
    private titleService: Title,
    public auth: AuthService,
    public sa: SchoolsService,
    private ups: UnivPrefsService,
    private router: Router,
    public epl: EplService
  ) {
    this.titleService.setTitle('Home' + ' | NPC Admin');
    this.ups.unload();
    this.userSchools = this.auth.user.pipe(
      map(user => {
        if (user) {
          if (user.schools) {
            if (user.schools.length === 1) {
              this.router.navigate([user.schools[0] + '/dashboard']);
            }
          }
          return (user.schools || []);
        } else {
          return [];
        }
      })
    );

    this.filteredSchools = combineLatest([
      this.schoolSearchControl.valueChanges.pipe(startWith('')),
      this.sa.allSchools,
      this.auth.user,
    ]).pipe(
      map(([value, allSchools, user]) => this.filterSchools(this.getSelectableSchools(allSchools, user), value))
    );
  }

  displaySchool(school: School): string {
    return school?.name ?? '';
  }

  onSchoolSelected(event: MatAutocompleteSelectedEvent): void {
    const school = event.option.value as School;
    if (school?.id && !this.isSchoolDeactivated(school)) {
      this.router.navigate(['../' + school.id + '/dashboard']);
      this.schoolSearchControl.setValue('');
    }
  }

  isSchoolDeactivated(school: School): boolean {
    return !!school.disabledDate && (school.status === 'DEACTIVATED' || !school.status);
  }

  getCodes(schools: School[]) {
    prompt('Use this list of school codes for conversion purposes', this.sa.buildAllSchoolsString(schools));
  }

  private getSelectableSchools(allSchools: School[], user: User | null): School[] {
    if (!user) {
      return [];
    }
    if (user.admin) {
      return allSchools;
    }
    return (user.schools || []).map(id => {
      const school = allSchools.find(entry => entry.id === id);
      return school ?? { id, name: id, demo: false, status: 'LIVE' as const };
    });
  }

  private filterSchools(schools: School[], value: string | School | null): School[] {
    if (!value || typeof value !== 'string') {
      return schools;
    }
    const filterValue = value.toLowerCase();
    return schools.filter(school =>
      school.name.toLowerCase().includes(filterValue) ||
      (school.id?.toLowerCase().includes(filterValue) ?? false)
    );
  }
}



